import BgIcon from "../../images/gallery/bg-icon.png";

function Gallery() {
  return (
    <>
      <section id="gallery" className="relative py-12 sm:py-16 md:py-20">
        <img src={BgIcon} alt="bg_img" className="absolute top-[30px] right-0 opacity-10 pointer-events-none" />

        <div className="container page-padding">
          {/* title div -- */}
          <div className="flex flex-col text-center relative items-center mb-8 sm:mb-12">
            <div className="relative inline-flex items-center justify-center gap-2 bg-[#ff0336] text-white text-[12px] sm:text-[13px] uppercase font-bold tracking-[3px] px-6 py-2 rounded-lg transform -skew-x-12 shadow-lg shadow-[#ff0336]/20 mb-4">
              <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse"></span>
              <span>FAT2FIT GALLERY</span>
            </div>

            <h2 className="text-[24px] sm:text-[30px] md:text-[34px] font-bold mb-3 text-black">Our Workspace Gallery</h2>
            <p className="text-[#646464] font-medium text-[14px] sm:text-[15px] max-w-lg leading-relaxed">
              Explore our unisex fitness zones, custom equipment, and active workouts at FAT2FIT Centre.
            </p>
          </div>

          {/* gallery */}
          <div className="gallery-grid py-4 sm:py-8 w-full h-auto relative rounded-2xl overflow-hidden">
            <div id="item-0" className="rounded-xl overflow-hidden"></div>
            <div id="item-1" className="rounded-xl overflow-hidden"></div>
            <div id="item-2" className="rounded-xl overflow-hidden"></div>
            <div id="item-3" className="rounded-xl overflow-hidden"></div>
            <div id="item-4" className="rounded-xl overflow-hidden"></div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Gallery;
